import Vue from 'vue'
import nopermission from "./settings/nopermission"
const component = Vue.component("nopermission", nopermission)
//button permission
const has = Vue.directive('has', {
  bind: function (el, binding, vnode) {
    let node = el.dataset.permissions;
    if (node) {
      let btnPermissions = new Set(node.split(","));
      if (!Vue.prototype.$_has(btnPermissions)) {
        if (binding.value) {
          binding.value.set[binding.value.name] = binding.value.val;
         
        }
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        } else {
          let childs = el.childNodes;
          if (childs.length > 0) {
            childs.forEach(element => {
              el.removeChild(element);
            });
          }
        }
      }
    }
  }
});

const routerHas = Vue.directive('has-router', {
  bind: function (el, binding, vnode) {
    let node = el.dataset.permissions;
    if (node) {
      let btnPermissions = new Set(node.split(","));
      if (!Vue.prototype.$_has(btnPermissions)) {
        Vue.nextTick(() => {
          el.parentNode.removeChild(el);
        })
      }
    }
  }
})
const pageHas = Vue.directive('has-page', {
  bind: function (el, binding, vnode) {
    let node = el.dataset.permissions;
    if (node) {
      let btnPermissions = new Set(node.split(","));
      if (!Vue.prototype.$_has(btnPermissions)) {
        Vue.nextTick(() => {
          el.innerHTML=`<div id='index1'></div>`
          new component().$mount('#index1')
        })
      }
    }
  },
})

Vue.prototype.$_has = function (value) {
  let isExist = false;
  let btnPermissionsStr = sessionStorage.getItem("btnPermissions");
  if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
    return false;
  }
  let permissionArray = new Set(btnPermissionsStr.split(","));
  let result = new Set([...value].filter(v => permissionArray.has(v)))
  if (result.size > 0) {
    isExist = true;
  }
  return isExist;
};
export { has, routerHas, pageHas }